export const ORDER_BOOKS_FETCH = "ORDER_BOOKS_FETCH";
export const ORDER_BOOKS_FETCH_SUCCESSFUL = "ORDER_BOOKS_FETCH_SUCCESSFUL";
export const ORDER_BOOKS_FETCH_FAILED = "ORDER_BOOKS_FETCH_FAILED";
